import apiWorker from '../apiWorker'

const packages = {
    find        : ()           => apiWorker('get',   `/v1/admin/packages`),
    create      : (data)       => apiWorker('post',  `/v1/admin/packages`, data, true),
    update      : (_id, data)  => apiWorker('patch', `/v1/admin/packages/${_id}`, data, true),
    findById    : (_id)        => apiWorker('get',   `/v1/admin/packages/${_id}`, null, true),
}

export default packages;